import { render } from "./multiple-select-pill-search.vue?vue&type=template&id=121d2cca&ts=true"
import script from "./multiple-select-pill-search.vue?vue&type=script&lang=ts"
export * from "./multiple-select-pill-search.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__